import React from 'react';
import { PropTypes } from 'prop-types';
import pluralize from 'pluralize';
import { dollarAmount } from 'common/display/Money/DollarAmount';
import formatDate from 'common/utils/Dates/formatDate';
import { isSingleDate } from '../../../utils/serviceAuthorizationUtils';

function AuthorizationSummarySection({ authorization, isUnitBased, feeScheduleProgram }) {
  const isFspLoaded = !!feeScheduleProgram.id;
  const isSingleDateApproved = isSingleDate(authorization, 'approved');

  return (
    <div className="pt-6">
      <div className="grid grid-cols-2 gap-2 m-0 gap-x-24">
        {(authorization.approved_cents || authorization.approved_unit_amount) && isFspLoaded && (
          <div>
            <label className="block mb-4" htmlFor="authorized-amount">Authorized Amount</label>
            <p data-test-element="authorized-amount">
              {isUnitBased ?
                `${authorization.approved_unit_amount} ${pluralize(
                  feeScheduleProgram.unit || 'unit',
                  authorization.approved_unit_amount,
                )}` :
                dollarAmount(authorization.approved_cents, true)}
            </p>
          </div>
        )}
        {(authorization.approved_starts_at || authorization.approved_ends_at) && (
          <div>
            <label className="block mb-4" htmlFor="authorized-delivery-dates">
              {isSingleDateApproved ?
                'Authorized Service Delivery Date' :
                'Authorized Service Delivery Dates'}
            </label>
            <p data-test-element="authorized-delivery-dates">
              {isSingleDateApproved ?
                formatDate(authorization.approved_ends_at || authorization.approved_starts_at) :
                `${formatDate(authorization.approved_starts_at)} - ${
                  formatDate(authorization.approved_ends_at)
                }`}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

AuthorizationSummarySection.propTypes = {
  authorization: PropTypes.shape({
    approved_cents: PropTypes.number,
    approved_unit_amount: PropTypes.number,
    approved_starts_at: PropTypes.string,
    approved_ends_at: PropTypes.string,
  }).isRequired,
  isUnitBased: PropTypes.bool.isRequired,
  feeScheduleProgram: PropTypes.shape({
    id: PropTypes.string,
    unit: PropTypes.string,
  }).isRequired,
};

export default AuthorizationSummarySection;
